export default __webpack_public_path__ + "img/96e91b77363017a86420fad4a54726c8.svg";